import { render, staticRenderFns } from "./YouTubeRegularFilter.vue?vue&type=template&id=5b39df08&scoped=true"
import script from "./YouTubeRegularFilter.vue?vue&type=script&lang=js"
export * from "./YouTubeRegularFilter.vue?vue&type=script&lang=js"
import style0 from "./YouTubeRegularFilter.vue?vue&type=style&index=0&id=5b39df08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39df08",
  null
  
)

export default component.exports